/** @jsxImportSource @emotion/react */
import InfoTip, {P} from './info-tip';

const GenerateScheduleInfo = function () {
  return (
    <InfoTip
      info={
        <section css={{width: 300}}>
          <h3>自動產生班表</h3>
          <P>專區啟用後，依照預設班次自動產生班表。</P>
        </section>
      }
    />
  );
};

export default GenerateScheduleInfo;
